"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/url/index.ts
var url_exports = {};
__export(url_exports, {
  AUTH_TOKEN_PARAM: () => APP_AUTH_TOKEN_PARAM,
  CUSTOMER_SUPPORT_CHAT_URL: () => CUSTOMER_SUPPORT_CHAT_URL,
  FEATURE_REQUEST_PLATFORM_URL: () => FEATURE_REQUEST_PLATFORM_URL,
  HELP_PAGE_URL: () => HELP_PAGE_URL,
  LICENSING_PAGE_URL: () => LICENSING_PAGE_URL,
  PRICING_PAGE_URL: () => PRICING_PAGE_URL,
  TUTORIALS_PAGE_URL: () => TUTORIALS_PAGE_URL,
  buildAppUrl: () => buildAppUrl,
  buildEditorUrl: () => buildEditorUrl,
  buildImageProxyUrl: () => buildImageProxyUrl,
  buildOriginUrl: () => buildOriginUrl,
  buildProfileImageUrl: () => buildProfileImageUrl,
  buildSignupUrl: () => buildSignupUrl,
  buildWebsiteUrl: () => buildWebsiteUrl,
  isSVGImage: () => isSVGImage,
  isUnsplashImage: () => isUnsplashImage
});
module.exports = __toCommonJS(url_exports);

// src/url/utils.ts
var WEBSITE_URL = process.env.REACT_APP_WEBSITE_URL || process.env.NEXT_PUBLIC_WEBSITE_URL || process.env.EXPO_PUBLIC_WEBSITE_URL || "https://kittl.com";
var EDITOR_URL = process.env.REACT_APP_EDITOR_URL || process.env.NEXT_PUBLIC_EDITOR_URL || process.env.EXPO_PUBLIC_EDITOR_URL || "https://app.kittl.com";
var APP_URL_SCHEME = "kittl://";
var APP_AUTH_TOKEN_PARAM = "token";
var buildUrl = ({
  url = "",
  baseUrl,
  searchParams
}) => {
  if (typeof window === "undefined" && !baseUrl) {
    return "";
  }
  const result = new URL(url, baseUrl || window.location.origin);
  if (searchParams) {
    searchParams.forEach((value, key) => {
      result.searchParams.append(key, value);
    });
  }
  return result.toString();
};
var buildWebsiteUrl = (url) => {
  if (!url) {
    return WEBSITE_URL;
  }
  return buildUrl({ url, baseUrl: WEBSITE_URL });
};
var buildEditorUrl = (url) => {
  if (!url) {
    return EDITOR_URL;
  }
  return buildUrl({ url, baseUrl: EDITOR_URL });
};
var buildOriginUrl = (url) => {
  return buildUrl({ url });
};
var buildSignupUrl = () => {
  if (typeof window === "undefined") {
    return "";
  }
  if (window.location.origin.endsWith("kittl.com")) {
    return buildOriginUrl();
  }
  return window.location.pathname;
};
var HELP_PAGE_URL = buildWebsiteUrl("/help");
var CUSTOMER_SUPPORT_CHAT_URL = buildWebsiteUrl(
  "/help?gs_open_chat=true"
);
var TUTORIALS_PAGE_URL = buildWebsiteUrl("/tutorials");
var PRICING_PAGE_URL = buildWebsiteUrl("/pricing");
var LICENSING_PAGE_URL = buildWebsiteUrl("/licensing");
var FEATURE_REQUEST_PLATFORM_URL = "https://feedback.kittl.com/feature-requests";
var buildAppUrl = (url = "", params) => {
  const result = new URL(url, APP_URL_SCHEME);
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      result.searchParams.append(key, value);
    });
  }
  return result.toString();
};

// src/url/image/image.ts
var import_env = __toESM(require("@repo/env"));

// src/url/image/utils.ts
var import_detection = require("@repo/detection");
var defaultOutputFormat = "webp";
var defaultProxyWidth = 256;
var defaultProxyHeight = 256;
var defaultProxyScale = 1;
var tabletMaxImageSize = 2048;
var unsplashDomain = "https://images.unsplash.com";
var isSVGImage = (objectName) => objectName.endsWith(".svg");
var isUnsplashImage = (objectName) => objectName.startsWith(unsplashDomain);
var getNormalizedSize = (options) => {
  let width = options.width ?? defaultProxyWidth;
  let height = options.height ?? defaultProxyHeight;
  let scale = options.scale ?? defaultProxyScale;
  if (!(0, import_detection.isDesktopOperatingSystem)() && Math.max(width, height) * scale > tabletMaxImageSize) {
    width = height = tabletMaxImageSize;
    scale = defaultProxyScale;
  }
  return { width, height, scale };
};
var getImageFormat = (objectName, options) => {
  if (options.isUpload) {
    return isSVGImage(objectName) ? `@${defaultOutputFormat}` : "";
  }
  return options.keepFormat ? "" : `@${options.format ?? defaultOutputFormat}`;
};

// src/url/image/image.ts
var buildUnsplashImageUrl = (objectName, options = {}) => {
  const searchParams = new URLSearchParams(objectName.split("?")[1]);
  if (!searchParams.has("raw_url")) {
    searchParams.append("raw_url", "true");
  }
  const scale = getNormalizedSize(options).scale;
  if (options.crop) {
    const { width, height, cropX, cropY, realWidth, realHeight } = options.crop;
    const fpX = ((cropX ?? 0) + width / 2) / realWidth;
    const fpY = ((cropY ?? 0) + height / 2) / realHeight;
    const fpZ = Math.min(realWidth / width, realHeight / height);
    searchParams.append("fit", "crop");
    searchParams.append("crop", "focalpoint");
    searchParams.append("fp-z", `${fpZ}`);
    searchParams.append("fp-x", `${fpX}`);
    searchParams.append("fp-y", `${fpY}`);
    searchParams.append("w", `${width * scale}`);
    searchParams.append("h", `${height * scale}`);
  } else {
    searchParams.append("fit", "clip");
    if (options.width) {
      searchParams.append("w", `${options.width * scale}`);
    }
    if (options.height) {
      searchParams.append("h", `${options.height * scale}`);
    }
  }
  return buildUrl({ baseUrl: objectName, searchParams });
};
var buildImageProxyUrl = (objectName, options = {}) => {
  const { width, height, scale } = getNormalizedSize(options);
  if (isUnsplashImage(objectName)) {
    return buildUnsplashImageUrl(objectName, options);
  }
  let crop = "";
  if (options.crop) {
    const { width: width2, height: height2, cropX, cropY } = options.crop;
    crop = `/crop:${width2}:${height2}:nowe:${cropX}:${cropY}`;
  }
  const trim = options.trimSVG && isSVGImage(objectName) ? "/trim:0:FF00FF" : "";
  const enlarge = options.enlarge ? "/enlarge:t" : "";
  const extend = options.extend ? "/extend:t" : "";
  let name = objectName;
  let base = import_env.default.imageProxyUrl;
  if (options.seoObjectName && import_env.default.seoImageProxyUrl) {
    name = options.seoObjectName;
    base = import_env.default.seoImageProxyUrl;
  }
  const format = getImageFormat(objectName, options);
  return `${base}/pr:sharp/rs:fit:${width * scale}:${height * scale}:0${trim}${enlarge}${extend}${crop}/plain/${name}${format}`;
};
var buildProfileImageUrl = (profileImage, options) => {
  if (!profileImage) {
    return null;
  }
  return buildImageProxyUrl(`api/${profileImage}`, options);
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  AUTH_TOKEN_PARAM,
  CUSTOMER_SUPPORT_CHAT_URL,
  FEATURE_REQUEST_PLATFORM_URL,
  HELP_PAGE_URL,
  LICENSING_PAGE_URL,
  PRICING_PAGE_URL,
  TUTORIALS_PAGE_URL,
  buildAppUrl,
  buildEditorUrl,
  buildImageProxyUrl,
  buildOriginUrl,
  buildProfileImageUrl,
  buildSignupUrl,
  buildWebsiteUrl,
  isSVGImage,
  isUnsplashImage
});
